export const getCities = (languageFilters, countryId) => {
  const cities = [];

  if (languageFilters) {
    const country = languageFilters?.filter(
      (item) => item.countryId === parseInt(countryId, 10)
    )[0];

    if (countryId !== 0) {
      country?.schoolsByCity?.map((sc) => {
        cities.push({ id: sc.cityId, name: sc.city });
      });
    }
  }

  return cities;
};
